import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { RingFull, RingHalf } from "./GeoShapes";

const CYAN = "#00C2E8";

export default function Footer() {
  const [time, setTime] = useState("");

  useEffect(() => {
    const tick = () =>
      setTime(
        new Intl.DateTimeFormat("it-IT", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          timeZone: "Europe/Rome",
        }).format(new Date())
      );
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-[#0037e0] text-paper">
      <RingFull color={CYAN} className="pointer-events-none absolute -right-16 -top-16 h-56 w-56" />
      <div className="pointer-events-none absolute right-1/4 top-1/3 h-14 w-14 bg-magenta-brand" />
      <RingHalf color="#FFFFFF" className="pointer-events-none absolute -left-12 bottom-8 h-40 w-40" />

      <div className="relative mx-auto max-w-[1400px] px-5 pb-10 pt-20 sm:px-8">
        <div className="flex flex-col gap-10 border-b border-white/20 pb-14 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="mb-6 flex items-center gap-4">
              <img
                src="/assets/brand-logo-white.png"
                alt="Giuseppe Fasino — Modularità, Identità, Semplicità"
                data-testid="footer-logo"
                className="h-14 w-auto"
              />
            </div>
          </div>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
            className="group flex w-fit items-center gap-3 border border-white/30 px-6 py-4 font-mono text-xs tracking-wider transition-colors duration-300 hover:border-cyan-brand hover:bg-cyan-brand hover:text-ink"
          >
            TORNA IN ALTO
            <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1" />
          </button>
        </div>

        <div className="flex flex-col gap-3 pt-8 font-mono text-[11px] tracking-wider text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} GIUSEPPE FASINO — TUTTI I DIRITTI RISERVATI</span>
          <span data-testid="footer-clock">BARI (IT) — {time} CET</span>
          <a
            href="mailto:fasinogiuseppe52@gmail.com"
            className="transition-colors hover:text-white"
          >
            FASINOGIUSEPPE52@GMAIL.COM
          </a>
        </div>
      </div>
    </footer>
  );
}
